module.exports = __webpack_public_path__ + "img/events.4611d338.svg";